module.exports = __webpack_public_path__ + "img/37.b101e0dc.png";